export const COUNTRIES = [
  {
    code: 'US',
    name: 'United States',
    flag: '🇺🇸',
    currency: 'USD',
    dial: '+1',
    langugae: 'en',
    domain: 'https://carsnus.com',
  },
  {
    code: 'MX',
    name: 'Mexico',
    flag: '🇲🇽',
    currency: 'MXN',
    dial: '+52',
    langugae: 'es',
    domain: 'https://carsnus.com',
  },
  {
    code: 'PE',
    name: 'Peru',
    flag: '🇵🇪',
    currency: 'PEN',
    dial: '+51',
    langugae: 'es',
    domain: 'https://carsnus.pe',
  },
  {
    code: 'PK',
    name: 'Pakistan',
    flag: '🇵�',
    currency: 'PKR',
  dial: '+92',
    langugae: 'en',
    domain: 'https://www.carsnus.com',
  },
  {
    code: 'SG',
    name: 'Singapore',
    flag: '🇸🇬',
    currency: 'SGD',
    dial: '+65',
    langugae: 'en',
    domain: 'https://carsnus.com',
  },
];

export const LANGUAGES = [
  { code: 'en', name: 'English', native: 'English', dir: 'ltr', flag: '🇺🇸' },
  { code: 'es', name: 'Spanish', native: 'Español', dir: 'ltr', flag: '💬' },
];

export const genericTlds = new Set([
  "com", "net", "org", "io", "co", "app",
  "info", "biz", "edu", "gov", "tech", "ai"
]);
export const COUNTRY_LOCATION_CONFIGS = {
  PE: {
    useDropdownForm: true,
    departments: {
      Amazonas: [
        'Chachapoyas',
        'Bagua',
        'Bongará',
        'Condorcanqui',
        'Luya',
        'Rodríguez de Mendoza',
        'Utcubamba',
      ],
      'Áncash': [
        'Huaraz',
        'Aija',
        'Antonio Raymondi',
        'Asunción',
        'Bolognesi',
        'Carhuaz',
        'Carlos Fermín Fitzcarrald',
        'Casma',
        'Corongo',
        'Huari',
        'Huarmey',
        'Huaylas',
        'Mariscal Luzuriaga',
        'Ocros',
        'Pallasca',
        'Pomabamba',
        'Recuay',
        'Santa',
        'Sihuas',
        'Yungay',
      ],
      Apurímac: [
        'Abancay',
        'Andahuaylas',
        'Antabamba',
        'Aymaraes',
        'Chincheros',
        'Cotabambas',
        'Grau',
      ],
      Arequipa: [
        'Arequipa',
        'Camaná',
        'Caravelí',
        'Castilla',
        'Caylloma',
        'Condesuyos',
        'Islay',
        'La Unión',
      ],
      Ayacucho: [
        'Huamanga',
        'Cangallo',
        'Huanca Sancos',
        'Huanta',
        'La Mar',
        'Lucanas',
        'Parinacochas',
        'Páucar del Sara Sara',
        'Sucre',
        'Víctor Fajardo',
        'Vilcas Huamán',
      ],
      Cajamarca: [
        'Cajamarca',
        'Cajabamba',
        'Celendín',
        'Chota',
        'Contumazá',
        'Cutervo',
        'Hualgayoc',
        'Jaén',
        'San Ignacio',
        'San Marcos',
        'San Miguel',
        'San Pablo',
        'Santa Cruz',
      ],
      Callao: [
        'Callao',
        'Bellavista',
        'Carmen de La Legua Reynoso',
        'La Perla',
        'La Punta',
        'Mi Perú',
        'Ventanilla',
      ],
      Cusco: [
        'Cusco',
        'Acomayo',
        'Anta',
        'Calca',
        'Canas',
        'Canchis',
        'Chumbivilcas',
        'Espinar',
        'La Convención',
        'Paruro',
        'Paucartambo',
        'Quispicanchi',
        'Urubamba',
      ],
      Huancavelica: [
        'Huancavelica',
        'Acobamba',
        'Angaraes',
        'Castrovirreyna',
        'Churcampa',
        'Huaytará',
        'Tayacaja',
      ],
      'Huánuco': [
        'Huánuco',
        'Ambo',
        'Dos de Mayo',
        'Huacaybamba',
        'Huamalíes',
        'Lauricocha',
        'Leoncio Prado',
        'Marañón',
        'Pachitea',
        'Puerto Inca',
        'Yarowilca',
      ],
      Ica: [
        'Ica',
        'Chincha',
        'Nazca',
        'Palpa',
        'Pisco',
      ],
      Junín: [
        'Huancayo',
        'Chanchamayo',
        'Chupaca',
        'Concepción',
        'Jauja',
        'Junín',
        'Satipo',
        'Tarma',
        'Yauli',
      ],
      'La Libertad': [
        'Trujillo',
        'Ascope',
        'Bolívar',
        'Chepén',
        'Gran Chimú',
        'Julcán',
        'Otuzco',
        'Pacasmayo',
        'Pataz',
        'Sánchez Carrión',
        'Santiago de Chuco',
        'Virú',
      ],
      Lambayeque: [
        'Chiclayo',
        'Ferreñafe',
        'Lambayeque',
      ],
      Lima: [
        'Barranca',
        'Cajatambo',
        'Canta',
        'Cañete',
        'Huaral',
        'Huarochirí',
        'Huaura',
        'Oyón',
        'Yauyos',
      ],
      'Lima Metropolitana': [
        'Ancón',
        'Ate',
        'Barranco',
        'Breña',
        'Carabayllo',
        'Chaclacayo',
        'Chorrillos',
        'Cieneguilla',
        'Comas',
        'El Agustino',
        'Independencia',
        'Jesús María',
        'La Molina',
        'La Victoria',
        'Lima',
        'Lince',
        'Los Olivos',
        'Lurigancho',
        'Lurín',
        'Magdalena del Mar',
        'Miraflores',
        'Pachacámac',
        'Pucusana',
        'Pueblo Libre',
        'Puente Piedra',
        'Punta Hermosa',
        'Punta Negra',
        'Rímac',
        'San Bartolo',
        'San Borja',
        'San Isidro',
        'San Juan de Lurigancho',
        'San Juan de Miraflores',
        'San Luis',
        'San Martín de Porres',
        'San Miguel',
        'Santa Anita',
        'Santa María del Mar',
        'Santa Rosa',
        'Santiago de Surco',
        'Surquillo',
        'Villa El Salvador',
        'Villa María del Triunfo',
      ],
      Loreto: [
        'Maynas',
        'Alto Amazonas',
        'Datem del Marañón',
        'Loreto',
        'Mariscal Ramón Castilla',
        'Putumayo',
        'Requena',
        'Ucayali',
      ],
      'Madre de Dios': [
        'Tambopata',
        'Manu',
        'Tahuamanu',
      ],
      Moquegua: [
        'Mariscal Nieto',
        'General Sánchez Cerro',
        'Ilo',
      ],
      Pasco: [
        'Pasco',
        'Oxapampa',
        'Daniel Alcides Carrión',
      ],
      Piura: [
        'Piura',
        'Ayabaca',
        'Huancabamba',
        'Morropón',
        'Paita',
        'Sechura',
        'Sullana',
        'Talara',
      ],
      Puno: [
        'Puno',
        'Azángaro',
        'Carabaya',
        'Chucuito',
        'El Collao',
        'Huancané',
        'Lampa',
        'Melgar',
        'Moho',
        'San Antonio de Putina',
        'San Román',
        'Sandia',
        'Yunguyo',
      ],
      'San Martín': [
        'Moyobamba',
        'Bellavista',
        'El Dorado',
        'Huallaga',
        'Lamas',
        'Mariscal Cáceres',
        'Picota',
        'Rioja',
        'San Martín',
        'Tocache',
      ],
      Tacna: [
        'Tacna',
        'Candarave',
        'Jorge Basadre',
        'Tarata',
      ],
      Tumbes: [
        'Tumbes',
        'Contralmirante Villar',
        'Zarumilla',
      ],
      Ucayali: [
        'Coronel Portillo',
        'Atalaya',
        'Padre Abad',
        'Purús',
      ],
    },
  },
  CO: {
    useDropdownForm: true,
    departments: {
      'Bogotá D.C.': ['Bogotá'],
      Amazonas: [
        'Leticia',
        'Puerto Nariño',
        'El Encanto',
        'La Chorrera',
        'La Pedrera',
        'Mirití-Paraná',
        'Puerto Alegría',
        'Puerto Arica',
        'Puerto Santander',
        'Tarapacá',
      ],
      Antioquia: [
        'Medellín',
        'Bello',
        'Envigado',
        'Itagüí',
        'Apartadó',
        'Rionegro',
        'Turbo',
        'Caucasia',
        'Sabaneta',
        'La Ceja',
        'Copacabana',
      ],
      Arauca: [
        'Arauca',
        'Saravena',
        'Tame',
        'Arauquita',
        'Fortul',
        'Puerto Rondón',
        'Cravo Norte',
      ],
      'Archipiélago de San Andrés, Providencia y Santa Catalina': [
        'San Andrés',
        'Providencia',
      ],
      Atlántico: [
        'Barranquilla',
        'Soledad',
        'Malambo',
        'Galapa',
        'Sabanalarga',
        'Baranoa',
        'Puerto Colombia',
      ],
      Bolívar: [
        'Cartagena',
        'Magangué',
        'Turbaco',
        'El Carmen de Bolívar',
        'Mompós',
        'Arjona',
      ],
      Boyacá: [
        'Tunja',
        'Duitama',
        'Sogamoso',
        'Chiquinquirá',
        'Paipa',
        'Puerto Boyacá',
      ],
      Caldas: [
        'Manizales',
        'La Dorada',
        'Villamaría',
        'Chinchiná',
        'Riosucio',
        'Anserma',
      ],
      Caquetá: [
        'Florencia',
        'San Vicente del Caguán',
        'Puerto Rico',
        'Belén de los Andaquíes',
        'Cartagena del Chairá',
      ],
      Casanare: [
        'Yopal',
        'Aguazul',
        'Villanueva',
        'Tauramena',
        'Paz de Ariporo',
        'Trinidad',
      ],
      Cauca: [
        'Popayán',
        'Santander de Quilichao',
        'Puerto Tejada',
        'Patía',
        'Corinto',
        'Piendamó',
      ],
      Cesar: [
        'Valledupar',
        'Aguachica',
        'Codazzi',
        'La Jagua de Ibirico',
        'Bosconia',
        'El Copey',
      ],
      Chocó: [
        'Quibdó',
        'Istmina',
        'Riosucio',
        'Tadó',
        'Condoto',
        'Bahía Solano',
      ],
      Córdoba: [
        'Montería',
        'Lorica',
        'Sahagún',
        'Cereté',
        'Tierralta',
        'Montelíbano',
      ],
      Cundinamarca: [
        'Soacha',
        'Facatativá',
        'Zipaquirá',
        'Chía',
        'Fusagasugá',
        'Girardot',
        'Madrid',
        'Mosquera',
        'Funza',
      ],
      Guainía: [
        'Inírida',
        'Barranco Minas',
        'Mapiripana',
        'San Felipe',
        'Cacahual',
        'Pana Pana',
      ],
      Guaviare: [
        'San José del Guaviare',
        'Calamar',
        'El Retorno',
        'Miraflores',
      ],
      Huila: [
        'Neiva',
        'Pitalito',
        'Garzón',
        'La Plata',
        'Campoalegre',
        'Rivera',
      ],
      'La Guajira': [
        'Riohacha',
        'Maicao',
        'Uribia',
        'Manaure',
        'San Juan del Cesar',
        'Fonseca',
      ],
      Magdalena: [
        'Santa Marta',
        'Ciénaga',
        'Fundación',
        'El Banco',
        'Plato',
        'Aracataca',
      ],
      Meta: [
        'Villavicencio',
        'Acacías',
        'Granada',
        'San Martín',
        'Puerto López',
        'Cumaral',
      ],
      Nariño: [
        'Pasto',
        'Tumaco',
        'Ipiales',
        'Túquerres',
        'La Unión',
        'Samaniego',
      ],
      'Norte de Santander': [
        'Cúcuta',
        'Ocaña',
        'Pamplona',
        'Villa del Rosario',
        'Los Patios',
        'Tibú',
      ],
      Putumayo: [
        'Mocoa',
        'Puerto Asís',
        'La Hormiga',
        'Orito',
        'Valle del Guamuez',
        'Sibundoy',
      ],
      Quindío: [
        'Armenia',
        'Calarcá',
        'Montenegro',
        'Quimbaya',
        'La Tebaida',
        'Circasia',
      ],
      Risaralda: [
        'Pereira',
        'Dosquebradas',
        'Santa Rosa de Cabal',
        'La Virginia',
        'Marsella',
        'Belén de Umbría',
      ],
      Santander: [
        'Bucaramanga',
        'Floridablanca',
        'Girón',
        'Barrancabermeja',
        'Piedecuesta',
        'San Gil',
      ],
      Sucre: [
        'Sincelejo',
        'Corozal',
        'San Marcos',
        'Sampués',
        'Tolú',
        'Morroa',
      ],
      Tolima: [
        'Ibagué',
        'Espinal',
        'Melgar',
        'Honda',
        'Líbano',
        'Chaparral',
      ],
      'Valle del Cauca': [
        'Cali',
        'Palmira',
        'Buenaventura',
        'Tuluá',
        'Cartago',
        'Buga',
        'Jamundí',
        'Yumbo',
      ],
      Vaupés: [
        'Mitú',
        'Carurú',
        'Pacoa',
        'Taraira',
        'Papunaua',
        'Yavaraté',
      ],
      Vichada: [
        'Puerto Carreño',
        'La Primavera',
        'Santa Rosalía',
        'Cumaribo',
      ],
    },
  },
};

export const getLocationConfig = (countryCode) =>
  COUNTRY_LOCATION_CONFIGS[countryCode] ?? { useDropdownForm: false };
